<script setup>
const { openModal, viewType } = defineProps({
    openModal: {
        type: Function,
    },
    viewType: {
        type: String,
        default: true,
    },
});
</script>

<template>
    <div class="preview-controls" :data-view-type="viewType">
        <button
            class="file__control"
            @click="openModal"
            type="button"
            aria-label="Open modal view"
        >
            <svg
                class="icon__fullscreen"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clip-path="url(#clip0_1926_63537)">
                    <path
                        d="M7.42629 8.4871L8.48734 7.42605L3.22138 2.16008H6.79752V0.666748H0.666992V6.79728H2.16033V3.22113L7.42629 8.4871Z"
                    ></path>
                    <path
                        d="M3.22138 17.8402L8.48734 12.5742L7.42629 11.5132L2.16033 16.7791V13.203H0.666992V19.3335H6.79752V17.8402H3.22138Z"
                    ></path>
                    <path
                        d="M16.7796 2.16008L11.5137 7.42605L12.5747 8.4871L17.8407 3.22113L17.821 6.79728H19.334V0.666748H13.2035V2.16008H16.7796Z"
                    ></path>
                    <path
                        d="M19.334 13.203H17.821L17.8407 16.7791L12.5747 11.5132L11.5137 12.5742L16.7796 17.8402H13.2035V19.3335H19.334V13.203Z"
                    ></path>
                </g>
                <defs>
                    <clipPath id="clip0_1926_63537">
                        <rect
                            width="18.6667"
                            height="18.6667"
                            fill="white"
                            transform="translate(0.666992 0.666748)"
                        ></rect>
                    </clipPath>
                </defs>
            </svg>
        </button>
    </div>
</template>

<style lang="scss">
.preview-controls {
    top: 6px;
    right: 6px;
    position: absolute;
    pointer-events: none;

    &[data-view-type="portret"] {
        @media (max-width: 201px) {
            top: 0;
            right: 0;
        }
    }

    // Iframe container width.
    @media (min-width: 202px) {
        top: 6px;
        right: 6px;
    }

    // Iframe container width.
    @media (min-width: 280px) {
        top: 0.75rem;
        right: 0.75rem;
    }

    .file__control {
        pointer-events: all;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border: none;
        border-radius: 50%;
        background: #4a4a4a;
        color: white;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
            background: #2d2d2d;

            .icon__fullscreen {
                transform: scale(1.1);
            }
        }

        &:active .icon__fullscreen {
            transform: scale(0.9);
        }

        .icon__fullscreen {
            width: 20px;
            height: 20px;
            fill: white;
            transition: all 300ms ease-in-out;
        }

        // Iframe container width.
        @media (min-width: 280px) {
            width: 48px;
            height: 48px;

            .icon__fullscreen {
                width: 24px;
                height: 24px;
            }
        }
    }
}
</style>
